module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/subjects/subjects.component.css
// module id = ./src/app/subjects/subjects.component.css
// module chunks = main